import { FC, memo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { OutOfVotesAlert } from '@/components/molecules/Alert/OutOfVotesAlert'

import { formatRemainingTime } from '@/utils/date'

import { VoteType } from '../api'
import { useVoteButton } from '../hooks'
import { VoteButtonBase } from './VoteButtonBase'

export interface IVoteButtonProps {
  contestantId: UUID
  voteType: VoteType
  onVote?: (arg0: unknown) => void
  isActiveSlide: boolean
}

const VoteButtonComponent: FC<IVoteButtonProps> = ({
  contestantId,
  voteType,
  onVote,
  isActiveSlide,
}) => {
  const [outOfVotesAlertOpen, setOutOfVotesAlertOpen] = useState<boolean>(false)
  const { status, vote, areVotesAvailable, voteStatus } = useVoteButton({
    contestantId,
    isActiveSlide,
  })
  const { t } = useTranslation('common')

  const voteHandler = async () => {
    if (areVotesAvailable) {
      return onVote(vote(voteType))
    }
    setOutOfVotesAlertOpen(true)
  }

  return (
    <span className="mt-3 h-16">
      <VoteButtonBase status={status} onVote={voteHandler} />
      {voteStatus && voteStatus.voteType === VoteType.Upvote && (
        <div className="text-xs text-zinc-200 mt-2 text-left">
          {t('contest.voteAgainIn', {
            time: formatRemainingTime(voteStatus.timestamp),
          })}
        </div>
      )}
      <OutOfVotesAlert
        isOpen={outOfVotesAlertOpen}
        onDismiss={() => setOutOfVotesAlertOpen(false)}
      />
    </span>
  )
}

export const VoteButton = memo(VoteButtonComponent)
